<template>
  <myDialog
    :isDialog="isDialog"
    :title="type==3 ? '案件详情' :type==1 ? '新增案件' : '编辑案件'"
    :width="'1200px'"
    @handleClose="handleClose"
  >
    <template #content>
      <el-form ref="formRef" :model="formData" :rules="rules" label-width="170px" class="add-case-form">
        <!-- 案件基本信息 -->
        <div class="section-block">
          <div class="section-title">案件基本信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="申请年度" prop="applicationYear">
                <el-date-picker
                  v-model="formData.applicationYear"
                  type="year"
                  placeholder="请选择年份"
                  value-format="yyyy"
                  style="width: 100%"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="caseCode">
                <el-input
                  v-model="formData.caseCode"
                  placeholder="请输入序号(5位数字)"
                  v-if="type==1"
                  maxlength="5"
                />
                <el-input
                    v-else
                    v-model="formData.caseCode"
                    placeholder="请输入案件编号"
                    :disabled="true"
                />
                <div>格式：申请年度 + 序号（共9位）</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="type==3">
              <el-form-item label="受理状态" prop="acceptStatus">
               {{formData.acceptStatus==1 ?  '待受理' : '已受理'}}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 伤者信息 -->
        <div class="section-block">
          <div class="section-title">伤者信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="伤者姓名" prop="woundedName" required>
                <el-input
                    v-model="formData.woundedName"
                    placeholder="请输入伤者姓名"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="woundedIdNumber">
                <el-input
                    v-model="formData.woundedIdNumber"
                    placeholder="请输入身份证号"
                    :disabled="isView"
                    maxlength="18"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="woundedPhone">
                <el-input
                    v-model="formData.woundedPhone"
                    placeholder="请输入联系电话"
                    :disabled="isView"
                    maxlength="11"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系地址" prop="woundedAddress">
                <el-input
                    v-model="formData.woundedAddress"
                    placeholder="请输入联系地址"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 事故信息 -->
        <div class="section-block">
          <div class="section-title">事故信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="伤害类型" prop="accidentHarmTypeCode" required>
                <el-select
                    v-model="formData.accidentHarmTypeCode"
                    placeholder="请选择"
                    style="width: 100%"
                    :disabled="isView"
                >
                  <el-option
                      v-for="item in harmTypeOptions"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="事故发生或被诊断鉴定为职业病日期" prop="accidentDate" label-width="280px" required>
                <el-date-picker
                    v-model="formData.accidentDate"
                    type="date"
                    placeholder="请选择年/月/日"
                    value-format="yyyy-MM-dd 00:00:00"
                    style="width: 100%"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>

          </el-row>
        </div>
        <!-- 单位信息 -->
        <div class="section-block">
          <div class="section-title">单位信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="用人单位" prop="unitName" required>
                <el-input
                    v-model="formData.unitName"
                    placeholder="请输入用人单位名称"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业信用代码" prop="unitCreditCode">
                <el-input
                    v-model="formData.unitCreditCode"
                    placeholder="请输入企业信用代码"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="单位联系地址" prop="unitAddress">
                <el-input
                    v-model="formData.unitAddress"
                    placeholder="请输入单位联系地址"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位联系电话" prop="unitPhone">
                <el-input
                    v-model="formData.unitPhone"
                    placeholder="请输入单位联系电话"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="被委托人" prop="unitConsignorName">
                <el-input
                    v-model="formData.unitConsignorName"
                    placeholder="请输入被委托人姓名"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="被委托人身份证号码" prop="unitConsignorIdNumber">
                <el-input
                    v-model="formData.unitConsignorIdNumber"
                    placeholder="请输入被委托人身份证号码"
                    :disabled="isView"
                    maxlength="18"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="委托人手机号码" prop="unitConsignorPhone">
                <el-input
                    v-model="formData.unitConsignorPhone"
                    placeholder="请输入委托人手机号码"
                    :disabled="isView"
                    maxlength="11"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 申请人信息 -->
        <div class="section-block">
          <div class="section-title">申请人信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="申请人类型" prop="proposerTypeCode" required>
                <el-select
                  v-model="formData.proposerTypeCode"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="isView"
                >
                  <el-option
                    v-for="item in applicantTypeOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请人" prop="proposerName" required>
                <el-input
                  v-model="formData.proposerName"
                  placeholder="请输入申请人姓名或单位名称"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请方式" prop="proposerModeCode" required>
                <el-select
                  v-model="formData.proposerModeCode"
                  placeholder="请选择"
                  style="width: 100%"
                  :disabled="isView"
                >
                  <el-option
                    v-for="item in applyMethodOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请日期" prop="applyDate" required>
                <el-date-picker
                    v-model="formData.applyDate"
                    type="date"
                    placeholder="请选择年/月/日"
                    value-format="yyyy-MM-dd 00:00:00"
                    style="width: 100%"
                    :disabled="isView"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 近亲属信息：申请人类型为「近亲属」时显示 -->
        <div v-if="isApplicantRelative" class="section-block">
          <div class="section-title">近亲属信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="近亲属姓名" prop="nearRelativesName" required>
                <el-input
                  v-model="formData.nearRelativesName"
                  placeholder="请输入近亲属姓名"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="近亲属身份证号" prop="nearRelativesIdNumber" required>
                <el-input
                  v-model="formData.nearRelativesIdNumber"
                  placeholder="请输入近亲属身份证号"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="近亲属手机号" prop="nearRelativesPhone" required>
                <el-input
                  v-model="formData.nearRelativesPhone"
                  placeholder="请输入近亲属手机号"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 工会信息：申请人类型为「工会」时显示 -->
        <div v-if="isApplicantLaborUnion" class="section-block">
          <div class="section-title">工会信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工会负责人姓名" prop="laborUnionName" required>
                <el-input
                  v-model="formData.laborUnionName"
                  placeholder="请输入工会负责人姓名"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工会负责人身份证号" prop="laborUnionIdNumber" required>
                <el-input
                  v-model="formData.laborUnionIdNumber"
                  placeholder="请输入工会负责人身份证号"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工会负责人手机号" prop="laborUnionPhone" required>
                <el-input
                  v-model="formData.laborUnionPhone"
                  placeholder="请输入工会负责人手机号"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="工会授权书附件链接" prop="laborUnionAuthorization">
                <el-input
                  v-model="formData.laborUnionAuthorization"
                  placeholder="多个使用英文逗号分割"
                  :disabled="isView"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 受理审核信息 -->
        <div class="section-block">
          <div class="section-title">受理审核信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="审核意见" prop="reviewOpinion" >
               <el-input
                  v-model="formData.reviewOpinion"
                  placeholder=""
                  :disabled="type==3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="受理日期" prop="acceptData" >
<!--                <el-input-->
<!--                    v-model="formData.acceptData"-->
<!--                    placeholder=""-->
<!--                    :disabled="type==3"-->
<!--                />-->
                <el-date-picker
                  v-model="formData.acceptData"
                  type="date"
                  value-format="yyyy-MM-dd 00:00:00"
                  placeholder="请选择受理日期"
                  style="width: 100%;"
                  :disabled="type==3"
                  />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="受理人" prop="acceptUserName" >
                <el-input
                    v-model="formData.acceptUserName"
                    placeholder=""
                    :disabled="type==3"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核说明" prop="auditOpinion" >
                <el-input
                    v-model="formData.acceptExplain"
                    placeholder=""
                    :disabled="type==3"
                />
              </el-form-item>
            </el-col>

          </el-row>
        </div>
<!--        说明-->
        <div class="instructions-block" v-if="type == 1 || type == 2">
         <div class=""><i class="el-icon-warning-outline"></i>
           {{ type ==1?'填写':'编辑' }}说明：</div>
          <p style="margin-top: 8px">
            1. 标有*的字段为必填项</br>
            2. 案件编号格式为9位数字{{type ==1?':申请年度（4位） + 序号（5位），例：2026年度第1号案件为"202600001"':',例：202600001'}}</br>
            3. 选择申请人类型后，申请人字段将自动填充（单位自动填入用人单位名称，个人自动填入伤者姓名）</br>
           <span v-if="type==1">4. 案件保存后，将默认为不予受理状态，需要审核后才能受理</span>
          </p>
        </div>
      </el-form>
    </template>
    <template #footer>
      <template v-if="type==3">
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handleEdit" >编辑案件</el-button>
      </template>
      <template v-else>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">保存{{type ==1?'案件':'修改'}}</el-button>
      </template>
    </template>
  </myDialog>
</template>

<script>
import { getListByDictType } from '@/api/sys/dictData'

export default {
  name: 'AddCaseDialog',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => ({})
    },
    type:{
      type: Number,
      default: 1,//1 新增 2 编辑 3 查看
      //3 查看 时，formData 为 editData
    }
  },
  data() {
    const currentYear = new Date().getFullYear()
    return {
      submitLoading: false,
      applicantTypeOptions: [],
      applyMethodOptions: [],
      harmTypeOptions: [],
      formData: {
        applicationYear: String(currentYear),
        caseCode: '',
        proposerTypeCode: '',
        proposerTypeName: '',
        proposerName: '',
        nearRelativesName: '',
        nearRelativesIdNumber: '',
        nearRelativesPhone: '',
        laborUnionName: '',
        laborUnionIdNumber: '',
        laborUnionPhone: '',
        laborUnionAuthorization: '',
        proposerModeCode: '',
        proposerModeName: '',
        woundedName: '',
        woundedIdNumber: '',
        woundedPhone: '',
        woundedAddress: '',
        unitName: '',
        unitConsignorName: '',
        unitConsignorIdNumber: '',
        unitAddress: '',
        unitPhone: '',
        accidentHarmTypeCode: '',
        accidentHarmTypeName: '',
        accidentDate: '',
        applyDate: '',
        unitCreditCode: '',
        unitConsignorPhone: '',
        acceptData: '',
        acceptExplain: '',
        acceptUserName: '',
        reviewOpinion:'予以受理'
      },
      rules: {
        applicationYear: [
          { required: true, message: '请选择申请年度', trigger: 'change' }
        ],
        proposerTypeCode: [
          { required: true, message: '请选择申请人类型', trigger: 'change' }
        ],
        proposerName: [
          { required: true, message: '请输入申请人姓名或单位名称', trigger: 'blur' }
        ],
        proposerModeCode: [
          { required: true, message: '请选择申请人申请方式', trigger: 'change' }
        ],
        woundedName: [
          { required: true, message: '请输入伤者姓名', trigger: 'blur' }
        ],
        accidentHarmTypeCode: [
          { required: true, message: '请选择事故伤害类型', trigger: 'change' }
        ],
        accidentDate: [
          { required: true, message: '请选择事故日期', trigger: 'change' }
        ],
        applyDate: [
          { required: true, message: '请选择申请日期', trigger: 'change' }
        ],
        caseCode:[
          { required: true, message: '请输入案件编号', trigger: 'blur' }
          ,{pattern: /^\d+$/, message: '请输入正确的案件编号', trigger: 'blur'}
        ],
        unitConsignorPhone: [
          // { validator: (rule, value, callback) => {
          //   if (!/^1[3456789]\d{9}$/.test(value)) {
          //     callback(new Error('请输入正确的委托人手机号码'))
          //   } else {
          //     callback()
          //   }
          // }, trigger: 'blur' }
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的委托人手机号码', trigger: 'blur'}
        ],
        woundedPhone:[
            {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的伤者手机号码', trigger: 'blur'}
        ],
        unitConsignorIdNumber:[
          {
            pattern: /\d{17}[0-9Xx]/,
            message: '请输入正确的委托人身份证号码',
            trigger: 'blur'
          }
        ],
        woundedIdNumber:[
            { required: true, message: '请输入伤者身份证号码', trigger: 'blur' },
          {
            pattern: /\d{17}[0-9Xx]/,
            message: '请输入正确的伤者身份证号码',
            trigger: 'blur'
          }
        ],
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        nearRelativesName: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantRelative && !(value && value.trim())) {
              callback(new Error('请输入近亲属姓名'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
        nearRelativesIdNumber: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantRelative && !(value && value.trim())) {
              callback(new Error('请输入近亲属身份证号'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
        nearRelativesPhone: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantRelative && !(value && value.trim())) {
              callback(new Error('请输入近亲属手机号'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
        laborUnionName: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantLaborUnion && !(value && value.trim())) {
              callback(new Error('请输入工会负责人姓名'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
        laborUnionIdNumber: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantLaborUnion && !(value && value.trim()) && value.test(/\d{17}[0-9Xx]/)) {
              callback(new Error('请输入工会负责人身份证号'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
        laborUnionPhone: [
          { validator: (rule, value, callback) => {
            if (this.isApplicantLaborUnion && !(value && value.trim())) {
              callback(new Error('请输入工会负责人手机号'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isApplicantUnit() {
      const opt = this.applicantTypeOptions.find(o => String(o.dictValue) === String(this.formData.proposerTypeCode))
      return (opt && (opt.dictLabel || '').trim() === '单位')
    },
    isApplicantRelative() {
      const opt = this.applicantTypeOptions.find(o => String(o.dictValue) === String(this.formData.proposerTypeCode))
      return (opt && (opt.dictLabel || '').trim() === '近亲属')
    },
    isApplicantLaborUnion() {
      const opt = this.applicantTypeOptions.find(o => String(o.dictValue) === String(this.formData.proposerTypeCode))
      return (opt && (opt.dictLabel || '').trim() === '工会')
    },
  },
  watch: {
    isDialog(val) {
      if (val) {
        this.loadDictOptions().then(() => {
          this.$nextTick(() => {
            if (this.editData && Object.keys(this.editData).length) {
              this.fillFormFromEditData()
            } else {
              this.generateCodeIfEmpty()
            }
          })
        })
      } else {
        this.resetForm()
      }
    },
    'formData.proposerTypeCode'() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate([
          'unitName', 'nearRelativesName', 'nearRelativesIdNumber', 'nearRelativesPhone',
          'laborUnionName', 'laborUnionIdNumber', 'laborUnionPhone'
        ])
      })
    }
  },
  created() {
    this.loadDictOptions()
  },
  methods: {
    async loadDictOptions() {
      try {
        const [applicantRes, methodRes, harmRes] = await Promise.all([
          getListByDictType('identification_case_proposer_type').catch(() => ({ code: 200, data: [] })),
          getListByDictType('identification_case_proposer_mode').catch(() => ({ code: 200, data: [] })),
          getListByDictType('industrial_injury_harm_type').catch(() => ({ code: 200, data: [] }))
        ])
        if (applicantRes && applicantRes.code === 200 && applicantRes.data) {
          this.applicantTypeOptions = applicantRes.data
        }
        if (methodRes && methodRes.code === 200 && methodRes.data) {
          this.applyMethodOptions = methodRes.data
        }
        if (harmRes && harmRes.code === 200 && harmRes.data) {
          this.harmTypeOptions = harmRes.data
        }
      } catch (e) {
        console.warn('字典加载失败', e)
      }
    },
    generateCodeIfEmpty() {
      // if (!this.formData.caseCode && this.formData.applicationYear) {
      //   this.formData.caseCode = this.formData.applicationYear + '0001'
      // }
    },
    fillFormFromEditData() {
      const d = this.editData
      const harmOpt = this.harmTypeOptions.find(o => (o.dictLabel || '') === (d.accidentHarmTypeName || ''))
      const proposerTypeOpt = this.applicantTypeOptions.find(o => String(o.dictValue) === String(d.proposerTypeCode))
      const proposerModeOpt = this.applyMethodOptions.find(o => String(o.dictValue) === String(d.proposerModeCode))
      this.formData = {
        applicationYear: d.applicationYear || (d.applyDate ? String(d.applyDate).slice(0, 4) : String(new Date().getFullYear())),
        caseCode: d.caseCode || '',
        proposerTypeCode: d.proposerTypeCode || '',
        proposerTypeName: d.proposerTypeName || (proposerTypeOpt && proposerTypeOpt.dictLabel) || '',
        proposerName: d.proposerName || '',
        nearRelativesName: d.nearRelativesName || '',
        nearRelativesIdNumber: d.nearRelativesIdNumber || '',
        nearRelativesPhone: d.nearRelativesPhone || '',
        laborUnionName: d.laborUnionName || '',
        laborUnionIdNumber: d.laborUnionIdNumber || '',
        laborUnionPhone: d.laborUnionPhone || '',
        laborUnionAuthorization: d.laborUnionAuthorization || '',
        proposerModeCode: d.proposerModeCode || '',
        proposerModeName: d.proposerModeName || (proposerModeOpt && proposerModeOpt.dictLabel) || '',
        woundedName: d.woundedName || '',
        woundedIdNumber: d.woundedIdNumber || '',
        woundedPhone: d.woundedPhone || '',
        woundedAddress: d.woundedAddress || '',
        unitName: d.unitName || '',
        unitConsignorName: d.unitConsignorName || '',
        unitConsignorIdNumber: d.unitConsignorIdNumber || '',
        unitAddress: d.unitAddress || '',
        unitPhone: d.unitPhone || '',
        accidentHarmTypeCode: d.accidentHarmTypeCode || (harmOpt && harmOpt.dictValue) || '',
        accidentHarmTypeName: d.accidentHarmTypeName || (harmOpt && harmOpt.dictLabel) || '',
        accidentDate: d.accidentDate || '',
        applyDate: d.applyDate || '',
        unitCreditCode: d.unitCreditCode || '',
        unitConsignorPhone: d.unitConsignorPhone || '',
        acceptData: d.acceptData || '',
        acceptExplain: d.acceptExplain || '',
        acceptUserName: d.acceptUserName || '',
        acceptStatus: d.acceptStatus || '',
        reviewOpinion: d.reviewOpinion || '予以受理',
      }
    },
    handleClose() {
      this.$emit('handleClose')
      this.resetForm()
    },
    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
      const currentYear = new Date().getFullYear()
      this.formData = {
        applicationYear: String(currentYear),
        caseCode: '',
        proposerTypeCode: '',
        proposerTypeName: '',
        proposerName: '',
        nearRelativesName: '',
        nearRelativesIdNumber: '',
        nearRelativesPhone: '',
        laborUnionName: '',
        laborUnionIdNumber: '',
        laborUnionPhone: '',
        laborUnionAuthorization: '',
        proposerModeCode: '',
        proposerModeName: '',
        woundedName: '',
        woundedIdNumber: '',
        woundedPhone: '',
        woundedAddress: '',
        unitName: '',
        unitConsignorName: '',
        unitConsignorIdNumber: '',
        unitAddress: '',
        unitPhone: '',
        accidentHarmTypeCode: '',
        accidentHarmTypeName: '',
        accidentDate: '',
        applyDate: '',
        unitCreditCode: '',
        unitConsignorPhone: '',
        acceptData: '',
        acceptExplain: '',
        acceptUserName: '',
        acceptStatus: '',
        reviewOpinion: '予以受理',
      }
    },
    buildSubmitPayload() {
      const f = this.formData
      const proposerTypeOpt = this.applicantTypeOptions.find(o => String(o.dictValue) === String(f.proposerTypeCode))
      const proposerModeOpt = this.applyMethodOptions.find(o => String(o.dictValue) === String(f.proposerModeCode))
      const harmOpt = this.harmTypeOptions.find(o => String(o.dictValue) === String(f.accidentHarmTypeCode))
      return {
        caseCode: f.caseCode,
        applicationYear: f.applicationYear,
        proposerTypeCode: f.proposerTypeCode,
        proposerTypeName: (proposerTypeOpt && proposerTypeOpt.dictLabel) || f.proposerTypeName || '',
        proposerName: f.proposerName,
        nearRelativesName: f.nearRelativesName,
        nearRelativesIdNumber: f.nearRelativesIdNumber,
        nearRelativesPhone: f.nearRelativesPhone,
        laborUnionName: f.laborUnionName,
        laborUnionIdNumber: f.laborUnionIdNumber,
        laborUnionPhone: f.laborUnionPhone,
        laborUnionAuthorization: f.laborUnionAuthorization,
        proposerModeCode: f.proposerModeCode,
        proposerModeName: (proposerModeOpt && proposerModeOpt.dictLabel) || f.proposerModeName || '',
        woundedName: f.woundedName,
        woundedIdNumber: f.woundedIdNumber,
        woundedPhone: f.woundedPhone,
        woundedAddress: f.woundedAddress,
        unitName: f.unitName,
        unitConsignorName: f.unitConsignorName,
        unitConsignorIdNumber: f.unitConsignorIdNumber,
        unitAddress: f.unitAddress,
        unitPhone: f.unitPhone,
        accidentHarmTypeCode: f.accidentHarmTypeCode,
        accidentHarmTypeName: (harmOpt && harmOpt.dictLabel) || f.accidentHarmTypeName || '',
        accidentDate: f.accidentDate,
        applyDate: f.applyDate,
        unitCreditCode: f.unitCreditCode,
        unitConsignorPhone: f.unitConsignorPhone,
        acceptData: f.acceptData,
        acceptExplain: f.acceptExplain,
        acceptUserName: f.acceptUserName,
        acceptStatus: f.acceptStatus,
        reviewOpinion: f.reviewOpinion,
      }
    },
    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const submitData = this.buildSubmitPayload()
        this.$emit('submit', submitData)
      })
    },
    finishSubmit() {
      this.submitLoading = false
      this.handleClose()
    },
    failSubmit() {
      this.submitLoading = false
    },
  //   编辑案件
    handleEdit() {
      this.$emit('handleEdit', this.editData)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-case-form {
  height: 100%;
  min-height: 0;
}

.section-block {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding-left: 11px;
  margin-bottom: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: #297dee;
  }
}

/deep/ .el-form-item__label {
  color: #2a3347 !important;
  font-weight: 400;
  font-size: 16px;
  white-space: nowrap;
}

/deep/ .el-dialog__header {
  background: #297dee !important;
}

/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
.instructions-block{
  padding: 16px 28px;
  border-radius: 4px;
  background: rgba(254, 238, 238, 1);
  color: rgba(255, 62, 80, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 10%;
}
/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>
